import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Nav from 'react-bootstrap/Nav';
import Badge from './Badge';

const SectionItem = ({
  sectionsPerRepeatableSection,
  section,
  errPerSection,
  reqPerSection,
}) => {
  const sectionUrl = useMemo(() => section.sectionName.replace(/\s/g, ''), [section]);

  return (
    <>
      <Nav.Item className="waves-effect d-block">
        <Nav.Link
          eventKey={sectionUrl}
          key={sectionUrl}
        >
          {(!errPerSection[section.sectionName] && !reqPerSection[section.sectionName]) && <span className="fas fa-check text-success ml-1 mr-1 width-1" />}
          {errPerSection[section.sectionName] && (
            <Badge bg="Danger" marginRight>
              {errPerSection[section.sectionName].length}
            </Badge>
          )}
          {section.sectionLabel}
          {sectionsPerRepeatableSection[section.sectionName] && (
            <Badge bg="Secondary" placeRight>
              {sectionsPerRepeatableSection[section.sectionName] ? sectionsPerRepeatableSection[section.sectionName].length : 0}
            </Badge>
          )}
        </Nav.Link>
      </Nav.Item>
    </>
  );
};
SectionItem.propTypes = {
  sectionsPerRepeatableSection: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.bool)),
  section: PropTypes.shape().isRequired,
  errPerSection: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]))).isRequired,
  reqPerSection: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
};

export default SectionItem;
